import { Modal, Form, Button, Container } from "react-bootstrap";

const FormModal = ({
  show,
  title,
  fields = [],
  formData = {},
  errors = {},
  onClose,
  onSave,
  onChange,
  saveButtonText = "Save",
  cancelButtonText = "Cancel",
  saveButtonVariant = "success",
  cancelButtonVariant = "secondary",
  saveButtonDisabled = false,
  modalSize = "lg",
  customFooter = null,
  children = null,
}) => {
  const handleClose = () => {
    onClose();
  };

  const handleSave = () => {
    onSave();
  };

  const handleChange = (e) => {
    onChange(e);
  };

  const renderField = (field) => {
    const fieldValue = formData[field.name] || field.defaultValue || "";

    switch (field.type) {
      case "select":
        return (
          <Form.Select
            name={field.name}
            value={fieldValue}
            onChange={handleChange}
            required={field.required}
            disabled={field.disabled}
            style={field.style}
          >
            {field.placeholder && (
              <option value="" disabled>
                {field.placeholder}
              </option>
            )}
            {field.options?.map((option, idx) => (
              <option key={idx} value={option.value || option}>
                {option.label || option}
              </option>
            ))}
          </Form.Select>
        );

      case "textarea":
        return (
          <Form.Control
            as="textarea"
            rows={field.rows || 3}
            placeholder={field.placeholder}
            name={field.name}
            value={fieldValue}
            onChange={handleChange}
            maxLength={field.maxLength}
            minLength={field.minLength}
            required={field.required}
            disabled={field.disabled}
            style={field.style || { height: "100%" }}
          />
        );

      case "checkbox":
        return (
          <Form.Check
            type="checkbox"
            label={field.label}
            name={field.name}
            checked={fieldValue}
            onChange={handleChange}
            required={field.required}
            disabled={field.disabled}
            style={field.style}
          />
        );

      case "radio":
        return (
          <div>
            {field.options?.map((option, idx) => (
              <Form.Check
                key={idx}
                type="radio"
                label={option.label || option}
                name={field.name}
                value={option.value || option}
                checked={fieldValue === (option.value || option)}
                onChange={handleChange}
                required={field.required}
                disabled={field.disabled}
                style={field.style}
              />
            ))}
          </div>
        );

      case "date":
        return (
          <Form.Control
            type="date"
            name={field.name}
            value={fieldValue}
            onChange={handleChange}
            required={field.required}
            disabled={field.disabled}
            min={field.min}
            max={field.max}
            style={field.style}
          />
        );

      case "number":
        return (
          <Form.Control
            type="number"
            placeholder={field.placeholder}
            name={field.name}
            value={fieldValue}
            onChange={handleChange}
            min={field.min}
            max={field.max}
            step={field.step}
            required={field.required}
            disabled={field.disabled}
            style={field.style}
          />
        );

      case "email":
        return (
          <Form.Control
            type="email"
            placeholder={field.placeholder}
            name={field.name}
            value={fieldValue}
            onChange={handleChange}
            required={field.required}
            disabled={field.disabled}
            style={field.style}
          />
        );

      case "password":
        return (
          <Form.Control
            type="password"
            placeholder={field.placeholder}
            name={field.name}
            value={fieldValue}
            onChange={handleChange}
            minLength={field.minLength}
            maxLength={field.maxLength}
            required={field.required}
            disabled={field.disabled}
            style={field.style}
          />
        );

      case "custom":
        return field.component;

      default:
        return (
          <Form.Control
            type="text"
            placeholder={field.placeholder}
            name={field.name}
            value={fieldValue}
            onChange={handleChange}
            maxLength={field.maxLength}
            minLength={field.minLength}
            required={field.required}
            disabled={field.disabled}
            style={field.style}
          />
        );
    }
  };

  return (
    <Container className="mt-5">
      <Modal show={show} onHide={handleClose} centered size={modalSize}>
        <Modal.Title className="mt-4 mb-2 ps-3">{title}</Modal.Title>

        <Modal.Body>
          {children ? (
            children
          ) : (
            <Form>
              {fields.map((field, index) => (
                <Form.Group
                  key={field.name}
                  className={!errors[field.errorKey] ? "mb-4" : ""}
                  controlId={field.name}
                >
                  {field.label && (
                    <Form.Label>
                      {field.label}
                      {field.required && <span className="text-danger">*</span>}
                    </Form.Label>
                  )}

                  {renderField(field, index)}

                  <div style={{ marginBottom: "10px" }}>
                    {errors[field.errorKey] && (
                      <div className="text-danger ms-1">
                        {errors[field.errorKey]}
                      </div>
                    )}
                  </div>
                </Form.Group>
              ))}
            </Form>
          )}
        </Modal.Body>

        <Modal.Footer>
          {customFooter ? (
            customFooter
          ) : (
            <>
              <Button
                variant={cancelButtonVariant}
                onClick={handleClose}
                style={{
                  color: "#707782",
                  backgroundColor: "#E5E7EB",
                  width: "80px",
                  border: "none",
                }}
              >
                {cancelButtonText}
              </Button>
              <Button
                variant={saveButtonVariant}
                onClick={handleSave}
                disabled={saveButtonDisabled}
                style={{
                  color: "#FFFFFF",
                  backgroundColor: "#198754",
                  width: "80px",
                  border: "none",
                }}
              >
                {saveButtonText}
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default FormModal;
